import { useAppDescriptions } from '../product-descriptions';

import { EDITIONS } from './common/edition-options';
import { ProductCard } from './common/product-card';
import { useProductCardData } from './common/use-product-card-data';

export const JsmProductCard = () => {
	const { iconUrl, description } = useAppDescriptions().jsm;
	return (
		<ProductCard
			{...useProductCardData('jsm')}
			title="Jira Service Management"
			iconUrl={iconUrl}
			description={description}
			unitLabelPlural="agents"
			unitLabelSingular="agent"
			editions={EDITIONS}
		/>
	);
};
